// UI strings for reading progress (app/src/reading/): how far a lesson or a Kielioppi topic is
// read, "Jatka kohdasta, jossa olit", and what the lesson's check waits for. Finnish (default) and
// English side by side. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const readingFi = {
  /** Small print beside a lesson: "luettu 60 %", "luettu loppuun". */
  read: (pct: number) => (pct >= 100 ? 'luettu loppuun' : `luettu ${pct}\u00a0%`),
  /** The partner's reading (beside a straw tick). */
  mate: (name: string, pct: number) => (pct >= 100 ? `${name} luki loppuun` : `${name}: luettu ${pct}\u00a0%`),
  resume: 'Jatka kohdasta, jossa olit',
  /** The check before the reading is done: "Lue ensin:" and the list. */
  first: 'Lue ensin:',
  topic: (title: string) => `Kielioppi · ${title}`,
  /** The reading list is still loading on a new device. */
  checking: 'Katsotaan, mitä olet jo lukenut…',
  /** A topic read to the end, in the Kielioppi contents (screen readers). */
  topicRead: 'luettu',
};

export const readingEn: typeof readingFi = {
  read: (pct) => (pct >= 100 ? 'read to the end' : `read ${pct}%`),
  mate: (name, pct) => (pct >= 100 ? `${name} read it to the end` : `${name}: read ${pct}%`),
  resume: 'Continue where you left off',
  first: 'Read first:',
  topic: (title) => `Grammar · ${title}`,
  checking: 'Looking at what you have read…',
  topicRead: 'read',
};

// Messages.reading (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('reading', readingFi, readingEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof readingFi> {}
}
